import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#18181B',
            color: '#FAFAFA',
            fontSize: '14px',
            fontFamily: '"Inter", system-ui, sans-serif',
            borderRadius: '10px',
            padding: '12px 16px',
          },
          success: {
            iconTheme: { primary: '#16A34A', secondary: '#FAFAFA' },
          },
          error: {
            iconTheme: { primary: '#DC2626', secondary: '#FAFAFA' },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
